import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../lib/api';

export default function StaticPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/pages/${slug}`).then(r => { setPage(r.data); setLoading(false); })
      .catch(() => { setNotFound(true); setLoading(false); });
  }, [slug]);

  if (loading) return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="w-8 h-8 border-4 border-[#7551e8] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (notFound) return (
    <div className="max-w-3xl mx-auto px-4 py-16 text-center" data-testid="page-not-found">
      <h1 className="font-['Outfit'] text-3xl font-semibold text-[#0A0A0A] mb-4">Page Not Found</h1>
      <p className="text-[#52525B]">The page you're looking for doesn't exist yet.</p>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-4 py-12" data-testid={`static-page-${slug}`}>
      <h1 className="font-['Outfit'] text-3xl sm:text-4xl font-semibold text-[#0A0A0A] mb-8">{page.title}</h1>
      <div className="prose prose-zinc max-w-none prose-headings:font-['Outfit'] prose-headings:text-[#0A0A0A] prose-a:text-[#7551e8]"
        dangerouslySetInnerHTML={{ __html: page.content }} />
    </div>
  );
}
